import { GetIncidentByIdResponse } from '@EHSNavigator/backend';
import { useApiClients } from '../../client/api/useApiClient';
import ReportIncident from '../../views/ReportIncident';
import { useQuery } from '@tanstack/react-query';

export default function ReportIncidentPage() {
  const { IncidentReportingApi } = useApiClients();
  const { data = [] } = useQuery<GetIncidentByIdResponse['incident'][]>({
    queryKey: ['all-drafts'],
    queryFn: async () => {
      const response =
        await IncidentReportingApi.incidentReportingControllerGetDrafts();
      return response?.data.incidents;
    },
  });
  return (
    <>
      <ReportIncident draftIncidents={data} />
    </>
  );
}
